import { render, staticRenderFns } from "./navision-setting-config.vue?vue&type=template&id=72c8c59c&"
import script from "./navision-setting-config.vue?vue&type=script&lang=js&"
export * from "./navision-setting-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports